import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { getVFLByID } from "app/_services/ehs/VFLService";
import React, { useEffect, useState } from "react";
import { Accordion, Card, Col, Row } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import toastr from "toastr";
import VFLTimeline from "app/_pages/_healthSafetyEnvironment/VFL/component/VFLTimeline";
import ViewComments from "app/_pages/_healthSafetyEnvironment/IncidentManagement/ViewComments";
import VFLDetailsInfo from "app/_pages/_healthSafetyEnvironment/VFL/component/VFLDetailsInfo";
function VFLVIew({
  match: {
    params: { id },
  },
  history,
}) {
  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 1);
  const [form, setForm] = useState({});

  /**************** Use Effect *********************/

  useEffect(() => {
    if (!id) return;

    getVFLByID(id).then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/vfl");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;

      setForm({
        ...response.data,
      });
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          // {
          //   name: "My VFLs",
          //   path: "/health-safety-and-environment/vfl/my",
          // },
          { name: "View" },
        ]}
      />

      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader justify-content-between">
          <h3 className="text-capitalize mb-0">View</h3>
          {/* <BackBtn url={"/health-safety-and-environment/vfl"} /> */}

          {form.vflId && (
            <span className="mr-4">
              VFL ID: <strong>{form.vflId}</strong>
            </span>
          )}
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
          <div className="hseMenuLinks card">
            <a className={`${tab === 1 ? "active" : ""}`} href onClick={() => setTab(1)}>
              Timeline
            </a>
            {form?.incidentReviewsData?.length ? (
              <a
                className={`${tab === 2 ? "active" : ""}`}
                href
                onClick={() => setTab(2)}
              >
                Workflow Input
              </a>
            ) : (
              ""
            )}
            {/* )} */}
          </div>
        </div>

        <div className="ehsFormWrapper">
          <Row>
            <Col lg={9}>
              {tab === 1 && (
                <div className="pt-2">
                  <VFLTimeline form={form} />
                </div>
              )}
            </Col>

            {tab === 2 && (
              <Col lg={9}>
                {form.isBack === 1 && (
                  <p style={{ color: "red" }}>
                    {form?.backData?.length > 0 &&
                      form?.backData[form.backData.length - 1]?.comment}
                  </p>
                )}
                <ViewComments hideTitle comments={form?.incidentReviewsData} viewOnly />
              </Col>
            )}

            <Col lg={3}>
              <div className="mt-1">
                {/* <h5>You are editing as an VFL Officer.</h5> */}

                <Accordion>
                  <div className="mb-3">
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="10"
                      className="rightIncidentCard p-0"
                    >
                      <div className="rightInfoTitle">
                        VFL
                        <MdKeyboardArrowRight />
                      </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="10">
                      <Card.Body className="p-0">
                        <VFLDetailsInfo form={form} />
                      </Card.Body>
                    </Accordion.Collapse>
                  </div>
                </Accordion>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </div>
  );
}

export default VFLVIew;
